import { constants } from "../../../misc/helpers";
import MainTutorialScenario from "./MainTutorialScenario";

export default class MainTutorialScenarioSteps7And8 {
	didStartTourniqueteSetup: boolean;
	tryAgainShowed: boolean;
	constructor(private mainScenario: MainTutorialScenario, private onDone: () => void) {;
	}
	public locations = [
		{
			type: constants.placementType.wrong,
			position: 35,
		},
		{
			type: constants.placementType.correct1,
			position: 63,
		},
	];

	public get correctFirstTourniquetPlacementIndex(): number {
		return 2;
	}

	public start() {
		this.tryAgainShowed = false;
		this.step7ShowBleedingControlKit();
	}

	step7ShowBleedingControlKit() {
		this.mainScenario.doStuffIfStepsWereSkipped();
		var context = this;
		context.mainScenario.playSound('4', '1', () => {
			context.mainScenario.playSound('4', '2', () => {
				var data = {
					disabled: true,
					onSelectionChanged: (index: number) => {
						if (index === 1) {
							context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
							context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
							context.Step8TourniqueteAudio();
							// context.mainScenario.showTryAgainUI(false, false, () => context.step7ShowBleedingControlKit(), () => context.step8TourniqueteDragDrop([]));
						}
					},
					disableTourniqueteButton: false,
					disablePPEButton: true,
					disablePressureDressingButton: true
				};
				context.mainScenario.playSound('4', '3', () => {
					data.disabled = false;
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select the tourniquet.'});
				});
			});
		});
	}

	Step8TourniqueteAudio() {
		var context = this;
		this.mainScenario.playSequence('ApplyPressureEnd', null, ()=> {
		});
		context.mainScenario.playSound('4', '4', () => {
			context.mainScenario.playSound('4', '5', () => {
				context.step8TourniqueteDragDropIncorrect();
			});
		});
	}

	step8TourniqueteDragDropIncorrect() {
		var context = this;

		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.playSequence('TourniqueteSetup', null, () => {
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Drag the tourniquet to the incorrect location. KB - Tab to cycle placements, use spacebar to select the location.'});
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.TourniquetePlacement, {
				dispatch: this.mainScenario.gameManager.customData.dispatch,
				correctIndex1: context.correctFirstTourniquetPlacementIndex, 
				locations: context.locations,
				isTutorial: true,
				onDone: (selectedNumber: number, isWrong: boolean) => {
					if(isWrong) {
						context.mainScenario.gameManager.UiManager.hideaAllUis();
						context.mainScenario.showJITFeedback('This is incorrect', () => {
							context.mainScenario.playSound('4', '6', () => {
								context.step8TourniqueteDragDropCorrect();
							});
						});
					} 
					else {
						context.step8TourniqueteDragDropIncorrect();
					}
				}
			});
		});
	}

	step8TourniqueteDragDropCorrect() {
		var context = this;

		context.mainScenario.gameManager.UiManager.hideaAllUis();
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Drag the tourniquet to the correct location. KB - Tab to cycle placements, use spacebar to select the location.'});
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.TourniquetePlacement, {
				dispatch: this.mainScenario.gameManager.customData.dispatch,
				correctIndex1: context.correctFirstTourniquetPlacementIndex, 
				locations: context.locations,
				isPractice: true,
				onDone: (selectedNumber: number, isCorrect: boolean) => {
					if(isCorrect) {
						context.mainScenario.gameManager.UiManager.hideaAllUis();
						context.mainScenario.showJITFeedback("This is correct", () => {
							context.mainScenario.playSound('4', '7', () => {
								context.step9TourniqueteRotation();
							});
						});
					} 
					else {
						context.step8TourniqueteDragDropCorrect();
					}
				}
			});
	}

	step9TourniqueteRotation() {
		var context = this;
		var data = {
			disabled: true,
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onUpdate: (percentage: number) => {
				if (percentage > 3 && percentage < 4) {
					context.mainScenario.gameManager.UiManager.hideaAllUis();
					context.mainScenario.playSound('4', '9', () => {
							context.step2TryAgain()
					});
				}
			}
		};
		context.mainScenario.gameManager.UiManager.hideaAllUis();
			context.mainScenario.playSound('4', '8', () => {
				data.disabled = false;
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Drag the circle within the slider in a clockwise rotation. KB - Tab to circle slider then use the right arrow key.'});
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.TourniqueteRotation, data);
			});
	}

	private step2TryAgain() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to try again?',
			correctButton: {
				title: 'Try Again',
				greyedOut: true,
				onClick: () => { }
			},
			incorrectButton: {
				title: 'Next',
				greyedOut: true,
				onClick: () => { }
			}
		});
		context.mainScenario.playSound('4', '10', () => {
			context.mainScenario.playSound('4', '11', () => {
			});
		});
				context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Would you like to try again?',
					correctButton: {
						title: 'Try Again',
						onClick: () => context.step2TryAgainConfirmed()
					},
					incorrectButton: {
						title: 'Next',
						onClick: () => context.step2TryAgainAfter()
					}
				});

	}

	private step2TryAgainAfter() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
		context.mainScenario.playSequence('TourniquetLock', null, () => {
			context.onDone();
		});
	}

	private step2TryAgainConfirmed() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BinaryQuestion);
		context.mainScenario.playSequence('ResetTourniquete', null, () => {
			context.step7BShowBleedingControlKit();
		});
	}

	step7BShowBleedingControlKit() {
		var context = this;
		context.mainScenario.playSound('4', '1', () => {
			context.mainScenario.playSound('4', '2', () => {
				var data = {
					disabled: true,
					onSelectionChanged: (index: number) => {
						if (index === 1) {
							context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
							context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.Feedback);
							context.Step8BTourniqueteAudio();
							// context.mainScenario.showTryAgainUI(false, false, () => context.step7ShowBleedingControlKit(), () => context.step8TourniqueteDragDrop([]));
						}
					},
					disableTourniqueteButton: false,
					disablePPEButton: true,
					disablePressureDressingButton: true
				};
				context.mainScenario.playSound('4', '3', () => {
					data.disabled = false;
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, data);
					context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select the tourniquet.'});
				});
			});
		});
	}

	Step8BTourniqueteAudio() {
		var context = this;
		context.mainScenario.playSound('4', '4', () => {
			context.mainScenario.playSound('4', '5', () => {
				context.step8TourniqueteDragDropIncorrect();
			});
		});
	}

}